module.exports = __webpack_public_path__ + "static/media/YFI-FTM.bd94293a.png";